import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Icon, TextInput } from '@pella/sash-framework';
import { useSelector } from 'react-redux';
import { isValidPostal } from '../../../utilities/validations';
import { useLocation } from '../../../../context/LocationContext';

const FifteenMinuteLocationChange = ({ canHaveAppt, rep }) => {
	const { setLocation } = useLocation();
	const locations = useSelector((state) => state.locations);

	const [previousBranchID, setPreviousBranchID] = useState(locations?.market?.retail_branch_id);
	const [changeLocationState, setChangeLocationState] = useState(null);
	const [zip, setZip] = useState('');
	const [postalCode, setPostalCode] = useState(null);
	const [branchID, setBranchID] = useState(null);

	useEffect(() => {
		setPostalCode(locations?.market?.postal_code);
		setBranchID(locations?.market?.retail_branch_id);
	}, [locations]);

	return (
		<>
			<form
				autoComplete='off'
				onSubmit={(event) => {
					event.preventDefault();
					setPreviousBranchID(branchID);
					setLocation(zip);
					setChangeLocationState(null);
				}}
			>
				<div className='mt-2 flex items-center'>
					<Button
						color='tertiary-none'
						className='text-body-2 flex !w-fit items-center'
						onClick={() => setChangeLocationState('input')}
					>
						<Icon
							name='location_on'
							className='text-gray-60'
						/>
						{changeLocationState == null && (
							<>
								<span>{postalCode}</span>
								<span className='ml-2.5 font-normal capitalize underline'>{changeLocationState === 'input' ? 'Update' : 'Change'}</span>
							</>
						)}
						{changeLocationState === 'input' && (
							<TextInput
								id='zip'
								name='zip'
								value={zip}
								maxLength={7} //7 for Canadian postal codes
								groupClass='!m-0 w-[88px]'
								className='!max-h-[43.5px] !min-h-[43.5px]'
								onChange={(event) => setZip(event.target.value)}
								aria-label='Zip Code'
								autoComplete='postal-code'
							/>
						)}
					</Button>

					{changeLocationState === 'input' && (
						<Button
							type='submit'
							disabled={!isValidPostal(zip)}
							color='primary-alt'
							size='sm'
						>
							Update
						</Button>
					)}
				</div>
			</form>

			{previousBranchID !== branchID && canHaveAppt && (
				<Alert
					type='info'
					className='my-2'
					onClose={() => setPreviousBranchID(branchID)}
				>
					<p className='text-body-2 font-semibold'>{`Your Pella Expert has changed to ${rep?.author_name} based on your location.`}</p>
				</Alert>
			)}
			{previousBranchID !== branchID && !canHaveAppt && (
				<Alert
					type='error'
					className='my-2'
					onClose={() => setPreviousBranchID(branchID)}
				>
					<>
						<p className='text-body-2 font-semibold'>We&apos;re sorry, 15 minute calls are currently not offered in your area.</p>
						<p className='text-body-2 !mt-2 font-semibold'>For assistance, you can reach our Customer Service team at 877-473-5527 .</p>
					</>
				</Alert>
			)}
		</>
	);
};

FifteenMinuteLocationChange.propTypes = {
	canHaveAppt: PropTypes.bool,
	rep: PropTypes.object,
};

export default FifteenMinuteLocationChange;
